import axios from 'axios';
import {rootUrl,rootUrl_37} from './rootUrl.js';
const _axios = axios.create({
    timeout: 1000000 * 1000
});
_axios.defaults.withCredentials = true
export let file={
/*  batchUploadZip(params) {
    return axios.post(rootUrl + '/file/batchUploadZip', params)
  },*/
  download(params) {
    return axios({
        method: 'post',
        url: rootUrl + '/file/download',
        data: params, //formData
        responseType: 'blob'
    })
},

/*  getProgress(params) {
    return axios.get(rootUrl + '/file/getProgress', params)
  },*/
  upload(params) {
    const formData = new FormData();
    for(let i in params){
      formData.append(i, params[i]);
    }
    // return axios.post(rootUrl_37 + '/kx-fileService/file/upload', formData);//峰哥
    return axios.post(rootUrl + '/file/upload', formData);//文礼复制峰哥的接口;
  },
  uploadBase64 (params) {
    return axios.post(rootUrl + '/file/uploadBase64 ', params)
  },
  //时间戳
  createHashcodeAndFileIdUpload(params) {
    const formData = new FormData();
    for(let i in params){
      formData.append(i, params[i]);
    }
    return _axios({
      method: 'post',
      url: rootUrl + '/timestamp/createHashcodeAndFileId',
      data: formData,//formData
      // responseType: 'blob',
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
    })
  },
}



// WEBPACK FOOTER //
// ./src/service/file.js